export function hasNumberValue(valueString: string) {
  return valueString && !isNaN(Number(valueString));
}

export function hasValue(value: number | string | null | undefined) {
  return value !== null && value !== undefined;
}
